module.exports = __webpack_public_path__ + "static/media/QRCode_Light.359d45dd.svg";